<header class="site_header">
  <div class="container">
    <div class="menu-icon"   [class.active]="isActive" 
    (click)="toggleMenu()">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <figure class="header_logo" routerLink="/">
      <img src="{{ assetsConst.logo }}" alt="logo" />
    </figure>

    <ul class="nav_menu" [class.active]="isActive"  >
      @for (item of navMenu; track $index) {
        <li [routerLink]="item.path" (click)="toggleMenu()">
          {{ item.title }}
        </li>
      }
    </ul>
    <ul class="header_list_icon">
      <li>
        <figure routerLink="/support/notification">
          <img src="{{ assetsConst.NotificationIcon }}" alt="img" />
        </figure>
      </li>
      <li>
        <figure routerLink="/my-account/wishlist">
          <img src="{{ assetsConst.favIcon }}" alt="img" />
        </figure>
      </li>
      <li>
        <button class="btnn btn_primary" [matMenuTriggerFor]="menu">
          <img src="{{ assetsConst.userIcon }}" alt="img" />
        <span>  Account</span>
        </button>
        <mat-menu #menu="matMenu">
          @if(profile) {
            <button mat-menu-item routerLink="/my-account">My Profile</button>
  
            <button mat-menu-item routerLink="/my-account/address">
              My Address
            </button>
            <button mat-menu-item routerLink="/checkout/cart">
              My Cart
            </button>
            <button mat-menu-item routerLink="/my-account/manage-order">
              My Orders
            </button>
            <button mat-menu-item routerLink="/my-account/wishlist">
              Wishlist
            </button>
          } @else {
            <button mat-menu-item (click)="loginModal()">
              {{'SignInSignup'|translate}}
            </button>
          }
        </mat-menu>
      </li>
    </ul>
  </div>
</header>
